import { createSelector, createStructuredSelector } from 'reselect'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getState = (state: any) => state.sidebar

export const getShow = createSelector(getState, ({ show }) => show)
export const getCollapse = createSelector(getState, ({ collapse }) => collapse)
export const getHidden = createSelector(getState, ({ hidden }) => hidden)

export const getSidebarFullData = createStructuredSelector({
  getShow,
  getCollapse,
})
